import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
// @mui
import { Box } from '@mui/material';
import { useCentro } from '../contextos/CentroContext';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title, meta, ...other }, ref) => {
  const { centro } = useCentro();
  const pageTitle = title ? `${title} | ${centro.nombre}` : centro.nombre;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        {meta}
      </Helmet>

      <Box ref={ref} {...other}>
        {children}
      </Box>
    </>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
